export default __webpack_public_path__ + "static/media/2270.244495f8.png";